__turbopack_context__.v({
  "search_pagination": "SearchPagination-module-scss-module__BpDzla__search_pagination",
});
